import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { XenaDSAccessor } from './xenads-accessor';

@Directive({
    selector: 'xena-autocomplete',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: XenaDSAutocompleteValueAccessorDirective, multi: true }],
    standalone: false
})
export class XenaDSAutocompleteValueAccessorDirective extends XenaDSAccessor implements ControlValueAccessor {
  constructor(element: ElementRef, renderer: Renderer2) {
    super(element, renderer, 'value');
  }

  @Input('datasource')
  set setDatasource(datasource: Promise<any[]>) {
    if (this.element.nativeElement.setDatasource)
      this.element.nativeElement.setDatasource(datasource);
  }

  @Input('idProperty')
  set idProperty(idProperty: string) {
    this.renderer.setProperty(this.element.nativeElement, 'idProperty', idProperty);
  }

  @Input('listLabelProperty')
  set listLabelProperty(listLabelProperty: ((e: any) => string) | string) {
    this.renderer.setProperty(this.element.nativeElement, 'listLabelProperty', listLabelProperty);
  }

  @Input('valueLabelProperty')
  set valueLabelProperty(valueLabelProperty: ((e: any) => string) | string) {
    this.renderer.setProperty(this.element.nativeElement, 'valueLabelProperty', valueLabelProperty);
  }

  async writeValue(value: any) {
    this.renderer.setProperty(this.element.nativeElement, 'value', value);
  }

  @HostListener('valueChange', ['$event'])
  handleValueChange(event: CustomEvent) {
    let value = event.detail !== null ? event.detail : null;
    event.stopPropagation();
    this.onChange(value);
    this.onTouched(); // TODO: Use xnBlur to trigger onTouched instead when support is added in XenaDS
  }

}
